import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import UserLicenseListSection from "../../../../../Header/UserProfile/LicenseDetailsDialog/UserLicenseDetails/UserLicenseCard/UserLicenseListSection";
import { LICENSE_SECTIONS_CONFIG } from "../../../../../Header/UserProfile/LicenseDetailsDialog/UserLicenseDetails/UserLicenseDetails.constants";

import { groupLicensePermissionsByCategory } from "../../../../../../utils/LicenseUtils";

const LicenseDetailsPermissionList = ({ licenseId, licensePermissions }) => {
  const { t } = useTranslation();

  const licenseSections = useMemo(() => {
    const entry = (licensePermissions || []).find(
      (perm) => perm.id === licenseId,
    );
    const groupedPermissions = groupLicensePermissionsByCategory(
      entry?.licensePermissions || [],
    );

    return LICENSE_SECTIONS_CONFIG.map(({ id, label, tag }) => ({
      id,
      label: t(label),
      licenseSectionData: groupedPermissions[tag] || [],
    }));
  }, [licensePermissions, licenseId, t]);

  return (
    <div className="user-license-permissions-layout column-layout">
      {licenseSections.map(({ id, label, licenseSectionData }) => (
        <div key={id} className="user-license-permissions">
          <UserLicenseListSection
            title={label}
            licenseSectionData={licenseSectionData}
            id={id}
            isCompact
          />
        </div>
      ))}
    </div>
  );
};

export default LicenseDetailsPermissionList;
